import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a319966"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-card-title mr-5" }
const _hoisted_2 = { class: "ml-auto" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Worker run UUID", -1))
const _hoisted_8 = { class: "control" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Worker version UUID", -1))
const _hoisted_12 = { class: "control" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Model version UUID", -1))
const _hoisted_16 = { class: "control" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Configuration ")
const _hoisted_21 = { class: "control" }
const _hoisted_22 = ["onClickCapture"]
const _hoisted_23 = ["checked", "disabled"]
const _hoisted_24 = { class: "control" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 1,
  class: "content"
}
const _hoisted_27 = {
  key: 0,
  class: "table is-fullwidth is-hoverable"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Worker version"),
    /*#__PURE__*/_createElementVNode("th", null, "Model version"),
    /*#__PURE__*/_createElementVNode("th", null, "Configuration"),
    /*#__PURE__*/_createElementVNode("th", { class: "is-narrow" }, "Actions")
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "content" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" You are about to delete all results from worker run ")
const _hoisted_35 = {
  key: 0,
  class: "notification is-warning"
}
const _hoisted_36 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Worker version: ")
const _hoisted_38 = { class: "tag" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" (worker ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Model version: ")
const _hoisted_43 = { class: "tag" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" (model ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "Expand configuration", -1))
const _hoisted_49 = { key: 3 }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" You are about to delete ")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "all worker results", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Child elements of these results will also be deleted recursively. ", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This action is irreversible.", -1))
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkerVersionSummary = _resolveComponent("WorkerVersionSummary")!
  const _component_ModelVersionSummary = _resolveComponent("ModelVersionSummary")!
  const _component_ConfigurationSummary = _resolveComponent("ConfigurationSummary")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Modal, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.updateModelValue,
      "is-large": !_ctx.advancedMode
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.truncateLong('Delete results ' + _ctx.originDescription)), 1),
        _createElementVNode("span", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: _ctx.advancedSwitchId,
            type: "checkbox",
            class: "switch is-rtl is-rounded is-info",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.advancedMode) = $event))
          }, null, 8, _hoisted_3), [
            [_vModelCheckbox, _ctx.advancedMode]
          ]),
          _createElementVNode("label", {
            class: "is-pulled-right mr-4",
            for: _ctx.advancedSwitchId
          }, "Advanced mode", 8, _hoisted_4)
        ])
      ]),
      footer: _withCtx(({ close }) => [
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, "Cancel", 8, _hoisted_32)
      ]),
      default: _withCtx(() => [
        (_ctx.advancedMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "00000000-0000-0000-0000-000000000000",
                    maxlength: "36",
                    class: "input uuid-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workerRunId) = $event)),
                    disabled: _ctx.loading || undefined
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.workerRunId]
                  ]),
                  (_ctx.errors.worker_run_id)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errors.worker_run_id, (err) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "help is-danger",
                          key: err
                        }, _toDisplayString(err), 1))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "00000000-0000-0000-0000-000000000000",
                    maxlength: "36",
                    class: "input uuid-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workerVersionId) = $event)),
                    disabled: _ctx.inWorkerRunMode || _ctx.loading || undefined
                  }, null, 8, _hoisted_13), [
                    [_vModelText, _ctx.workerVersionId]
                  ]),
                  (_ctx.errors.worker_version_id)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errors.worker_version_id, (err) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "help is-danger",
                          key: err
                        }, _toDisplayString(err), 1))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "00000000-0000-0000-0000-000000000000",
                    maxlength: "36",
                    class: "input uuid-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelVersionId) = $event)),
                    disabled: _ctx.inWorkerRunMode || _ctx.loading || undefined
                  }, null, 8, _hoisted_17), [
                    [_vModelText, _ctx.modelVersionId]
                  ]),
                  (_ctx.errors.model_version_id)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errors.model_version_id, (err) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "help is-danger",
                          key: err
                        }, _toDisplayString(err), 1))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("span", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurationRadio, (value, label) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: label,
                        class: _normalizeClass(["radio ml-4", { active: _ctx.configurationField === value }]),
                        onClickCapture: ($event: any) => (_ctx.setConfigurationField(value))
                      }, [
                        _createElementVNode("input", {
                          class: "is-checkradio",
                          type: "radio",
                          checked: 
                  (_ctx.configurationField === value && !_ctx.inWorkerRunMode) ||
                    undefined
                ,
                          disabled: _ctx.inWorkerRunMode || _ctx.loading || undefined
                        }, null, 8, _hoisted_23),
                        _createTextVNode(" " + _toDisplayString(label), 1)
                      ], 42, _hoisted_22))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "00000000-0000-0000-0000-000000000000",
                    maxlength: "36",
                    class: "input uuid-input",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configurationId) = $event)),
                    disabled: 
              _ctx.inWorkerRunMode ||
                _ctx.configurationField !== true ||
                _ctx.loading ||
                undefined
            
                  }, null, 8, _hoisted_25), [
                    [_vModelText, _ctx.configurationId]
                  ]),
                  (_ctx.errors.configuration_id)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errors.configuration_id, (err) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "help is-danger",
                          key: err
                        }, _toDisplayString(err), 1))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                class: "button is-danger",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkManual && _ctx.checkManual(...args)))
              }, " Delete ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_ctx.workerVersionsCache)
                ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workerVersionsCache, ({ worker_version, worker_configuration, model_version }, cacheId) => {
                        return (_openBlock(), _createElementBlock("tr", { key: cacheId }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_WorkerVersionSummary, { "worker-version": worker_version }, null, 8, ["worker-version"])
                          ]),
                          _createElementVNode("td", null, [
                            model_version
                              ? (_openBlock(), _createBlock(_component_ModelVersionSummary, {
                                  key: 0,
                                  "model-version": model_version
                                }, null, 8, ["model-version"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_29
                                ], 64))
                          ]),
                          _createElementVNode("td", null, [
                            worker_configuration
                              ? (_openBlock(), _createBlock(_component_ConfigurationSummary, {
                                  key: 0,
                                  configuration: worker_configuration,
                                  "worker-version": worker_version
                                }, null, 8, ["configuration", "worker-version"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_30
                                ], 64))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "button is-danger",
                              type: "button",
                              onClick: ($event: any) => (_ctx.select(cacheId))
                            }, " Delete ", 8, _hoisted_31)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]),
      _: 1
    }, 8, ["model-value", "onUpdate:modelValue", "is-large"]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.confirmationModal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.confirmationModal) = $event)),
      title: "Confirm deletion"
    }, {
      footer: _withCtx(({ close }) => [
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, "Cancel", 8, _hoisted_55),
        _createElementVNode("button", {
          class: "button is-danger",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.performDelete && _ctx.performDelete(...args))),
          title: _ctx.originDescription
        }, _toDisplayString(_ctx.truncateLong('Delete results ' + _ctx.originDescription)), 9, _hoisted_56)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          (_ctx.inWorkerRunMode)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", null, [
                  _hoisted_34,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.workerRunId), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.originDescription) + ". ", 1)
                ]),
                (!_ctx.targetWorkerRun)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, " The worker run details could not be retrieved. "))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_36, [
                      _createElementVNode("li", null, [
                        _hoisted_37,
                        _createVNode(_component_router_link, {
                          to: { name: 'worker-version', params: { versionId: _ctx.targetWorkerRun.worker_version.id } },
                          target: "_blank",
                          title: "See worker version details"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("samp", _hoisted_38, _toDisplayString(_ctx.targetWorkerRun.worker_version.id), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _hoisted_39,
                        _createVNode(_component_router_link, {
                          to: { name: 'worker-manage', params: { workerId: _ctx.targetWorkerRun.worker_version.worker.id } },
                          target: "_blank",
                          title: "See worker details"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.truncateShort(_ctx.targetWorkerRun.worker_version.worker.name)), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _hoisted_40
                      ]),
                      (_ctx.targetWorkerRun.model_version)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                            _hoisted_42,
                            _createVNode(_component_router_link, {
                              to: { name: 'model-version', params: { versionId: _ctx.targetWorkerRun.model_version.id } },
                              target: "_blank",
                              title: "See model version details"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("samp", _hoisted_43, _toDisplayString(_ctx.targetWorkerRun.model_version.id), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            _hoisted_44,
                            _createVNode(_component_router_link, {
                              to: { name: 'model', params: { modelId: _ctx.targetWorkerRun.model_version.model.id } },
                              target: "_blank",
                              title: "See model details"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.truncateShort(_ctx.targetWorkerRun.model_version.model.name)), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            _hoisted_45
                          ]))
                        : (_openBlock(), _createElementBlock("li", _hoisted_46, "Model version: —")),
                      (_ctx.targetWorkerRun.configuration)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                            _createTextVNode(" Configuration: " + _toDisplayString(_ctx.targetWorkerRun.configuration.name) + " ", 1),
                            _createElementVNode("details", null, [
                              _hoisted_48,
                              _createElementVNode("pre", null, _toDisplayString(JSON.stringify(_ctx.targetWorkerRun.configuration.configuration, null, 2)), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("li", _hoisted_49, "Configuration: —"))
                    ]))
              ], 64))
            : (_ctx.deletesAll)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_50,
                  _hoisted_51,
                  _createTextVNode(" " + _toDisplayString(_ctx.originDescription) + ". ", 1)
                ], 64))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.deleteMessages, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "mb-0",
                    key: index
                  }, _toDisplayString(item), 1))
                }), 128)),
          _hoisted_52,
          _hoisted_53,
          _hoisted_54
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}